import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=3b66499f&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=3b66499f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b66499f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b66499f')) {
      api.createRecord('3b66499f', component.options)
    } else {
      api.reload('3b66499f', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=3b66499f&scoped=true&", function () {
      api.rerender('3b66499f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sN1jSJLlG1Wi/JS/comp/DocBox.vue"
export default component.exports